export class PricingCardPrefill {
	productId: number;
	protectionLevelId?: number;
	pricingCardTypeId?: number;
	petProtectionScopeId?: number;
}
